import Section from "../components/Section";
import Button from "../components/Button";
import devphoto from "../assets/images/dev_pr.png";
import Services from "./Services";
import { NavLink } from "react-router-dom";
import ProjectsSt from "../components/stats/Projectstat";
function Home() {
  const rediPintrest = () => {
    window.location.href = "https://pin.it/1agZp2YNs";
  };

  const rediFacebook = () => {
    window.location.href = "https://www.facebook.com/devdavid.welengenzu.3";
  };

  const rediInstagram = () => {
    window.location.href =
      "https://www.instagram.com/dev__well/profilecard/?igsh=czc4dXlucmU1aWx1";
  };

  const rediLinkdin = () => {
    window.location.href = " https://www.linkedin.com/in/david-wele-b4509621b";
  };
  return (
    <Section>
      {" "}
      <div className="text-center flex flex-col space-y-8 px-10">
        <div className=" flex md:flex-row justify-between flex-col w-full space-y-8">
          <div className=" w-full flex flex-col justify-center items-center md:items-start">
            <div className=" md:w-96 w-auto">
              {" "}
              <h1 className=" mb-4 flex flex-col text-start">
                <span className=" text-orange-400 font-medium text-2xl">
                  Salut je suis
                </span>
                <span className="  text-blue-600  font-bold text-4xl ">
                  David well <strong className=" text-orange-400"> Ng</strong>
                </span>
                <span className="  dark:text-white  font-medium md:text-[18px] text-[17px] md:text-start text-justify">
                  Je suis un professionel polyvalent expert en UI/UX,
                  développement Web Community manager Conseiller informmatique.
                </span>
              </h1>{" "}
            </div>
            <div className="  md:w-96 w-auto flex justify-center  h-auto ">
              <p className="md:text-xl text-[16] text-blue-600 dark:text-white font-medium mb-6  text-justify  ">
                Soucieux de fournir des services de qualités, Je m'efforce de
                proposer des solutions adaptées aux besoins de mes clients.
              </p>{" "}
            </div>
            <NavLink to="projects">
              <div>
                <Button text="Voir mes projets" color="bg-blue-600" />{" "}
              </div>
            </NavLink>
          </div>
          <div className=" flex flex-col items-center">
            <div className=" w-full flex justify-center items-center">
              <div
                className=" md:w-[350px] w-[300px] md:h-[350px] h-[300px] bg-gray-100 dark:bg-[#010138]
                               flex justify-center items-center rounded-t-lg shadow-lg"
              >
                <div>
                  <img
                    src={devphoto}
                    alt=""
                    className=" w-full h-full shadow-xl"
                  />
                </div>
              </div>
            </div>
            <div
              className=" flex flex-row justify-center space-x-4 mt-0 rounded-b-lg shadow-lg
            text-2xl font-bold text-white bg-blue-600 p-3 md:w-[350px] w-[300px]"
            >
              <div>
                <button onClick={rediFacebook}>
                  <i className=" fab fa-facebook"></i>
                </button>
              </div>
              <div>
                <button onClick={rediInstagram}>
                  <i className=" fab fa-instagram"></i>
                </button>
              </div>
              <div>
                <button onClick={rediPintrest}>
                  <i className=" fab fa-pinterest"></i>
                </button>
              </div>
              <div>
                <button onClick={rediLinkdin}>
                  <i className=" fab fa-linkedin"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>{" "}
      <Services />
      <ProjectsSt />
    </Section>
  );
}
export default Home;
